'use client';

import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
export default function Banana(t0) {
  const $ = _c(6);
  const {
    reset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      backgroundImage: "[url(https://www.nerdwallet.com/cdn/img/background/error/ErrorPage_BananaPeel_green.png)]",
      height: "[100%]",
      backgroundColor: "[#65a989]",
      margin: "0",
      padding: "0",
      minHeight: "[100vh]",
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      textAlign: "center",
      fontFamily: "gotham",
      lineHeight: "[1.5rem]",
      display: "flex",
      flexDirection: "column",
      alignContent: "center"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div id="nw-heading-wrap" className={css({
      minHeight: "[100px]",
      position: "absolute",
      top: "[22vh]",
      width: "[100%]"
    })}><h1 className={css({
        color: "common.white",
        marginY: "0",
        marginX: "[auto]",
        letterSpacing: "[-0.67px]",
        maxWidth: "[350px]",
        display: "block"
      })}>Sorry, looks like something slipped up.</h1></div>;
    t3 = css({
      position: "absolute",
      width: "[100%]",
      top: "[77vh]"
    });
    t4 = css({
      cursor: "pointer",
      textDecoration: "none",
      color: "common.white",
      backgroundColor: "[#6cc551]",
      paddingY: "[7px]",
      paddingX: "[40px]",
      height: "[40px]",
      borderColor: "transparent",
      borderRadius: "sm",
      letterSpacing: "[-0.34px]",
      _hover: {
        textDecoration: "none",
        color: "blues.main",
        boxShadow: "[0 2px 5px 0 rgba(0,0,0,0.2)]"
      },
      _focus: {
        color: "blues.main",
        outlineWidth: "[2px]",
        outlineStyle: "solid",
        outlineColor: "[#4b99e6]",
        outlineOffset: "[4px]"
      },
      _visited: {
        color: "blues.main"
      },
      _active: {
        color: "blues.main"
      }
    });
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== reset) {
    t5 = <div id="nw-50x" className={t1}>{t2}<div className={t3}><button className={t4} type="button" onClick={reset}>Let's try that again!</button></div></div>;
    $[4] = reset;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}